const MissionSection = () => {
  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-[#0066FF] uppercase text-sm font-semibold tracking-wide mb-4">Our Mission</p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] mb-6">
              Empowering sport through people
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              We exist to help sports organisations and professionals reach their full potential. By combining HR expertise with sports industry knowledge, we create environments where talent thrives and performance flourishes.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Whether you're building a world-class academy, managing elite athletes, or transforming your organisation's culture, we're here to support your journey with practical, people-focused solutions.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-[#0066FF] mb-2">2022</div>
              <p className="text-gray-600 font-medium">Founded</p>
            </div>
            <div className="bg-white rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-[#0066FF] mb-2">8</div>
              <p className="text-gray-600 font-medium">Core Services</p>
            </div>
            <div className="bg-white rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-[#0066FF] mb-2">100%</div>
              <p className="text-gray-600 font-medium">Sports Focus</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
